<div class="catalog-header-section">
  <div class="container">
    <div class="catalog-header-wrap">
      <div class="catalog-header-img">
        <img
          alt="Auction img"
          [src]="
            auctionInfo?.auction?.image || '/assets/images/defualt-image.jpg'
          "
          />
        </div>
        <div class="catalog-header-content">
          <div class="catalog-title-section">
            <h1>
              {{ auctionInfo?.auction?.name | localizedName }}
            </h1>

            <span data-translation-key="buyer_catalogue_hosted_by">{{ 'buyer_catalogue.hosted_by' | translate }}</span
              ><br />
              <a [routerLink]="['/buyer/sellers/seller-details', consignorId]">
                <strong>
                  <span>{{ consignorName }}</span>
                </strong>
              </a>
            </div>
            @if (auctionInfo?.auc_type != 'previous') {
              <div
                class="catalog-timer-section"
                >
                @if (auctionInfo?.auc_type == 'upcoming') {
                  <p
                    class="countdown__title"
                    data-translation-key="buyer_catalogue_bids_star_at"
                    >
                    {{ 'buyer_catalogue.bids_star_at' | translate }}
                  </p>
                }
                @if (auctionInfo?.auc_type == 'active' && !gradualEnding) {
                  <p
                    class="countdown__title"
                    data-translation-key="buyer_catalogue_bids_end_at"
                    >
                    {{ 'buyer_catalogue.bids_end_at' | translate }}
                  </p>
                }
                <app-timer
            [endDate]="
              gradualEnding && gradualEnding?.next_item_finish_at
                ? gradualEnding?.next_item_finish_at
                : auctionInfo?.extended_end_date
            "
                  [startDate]="auctionInfo?.auction?.auction_start_date"
                  [currentDate]="auctionInfo?.currentDate"
                  [translations]="translations"
                  [auc_type]="auctionInfo?.auc_type"
                  [showProgressPar]="false"
                  (loadData)="fireTimeEnded()"
                  [countInUpcoming]="true"
                  [gradualEnding]="gradualEnding"
                  [isColon]="false"
                  [theme]="'dark'"
                ></app-timer>
              </div>
            }
            @if (
              auctionInfo?.auc_type == 'previous' &&
              auctionInfo.auction_settings?.ended
              ) {
              <div
                class="catalog-timer-section"
                >
                <p
                  class="countdown__title"
                  data-translation-key="buyer_catalogue_bids_ended_at"
                  >
                  {{ 'buyer_catalogue.bids_ended_at' | translate }}
                </p>
                <p class="date">
                  <strong>{{
                    auctionInfo?.extended_end_date | localDateTime : "longDate"
                  }}</strong>
                </p>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
